import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookies from 'js-cookie'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: () =>
            import('../pages/home.vue'),
    },
    {
        path: '/login',
        component: () =>
            import('../pages/login.vue'),
        meta: {
            guestOnly: true
        }
    },
    {
        path: '/register',
        component: () =>
            import('../pages/register.vue'),
        meta: {
            guestOnly: true
        }
    },
    {
        path: '/activate',
        component: () =>
            import('../pages/activate.vue'),
        meta: {
            guestOnly: true
        }
    },
    {
        path: '/recovery',
        component: () =>
            import('../pages/recovery.vue'),
        meta: {
            guestOnly: true
        }
    },
    {
        path: '/dashboard',
        component: () =>
            import('../pages/dashboard.vue'),
        meta: {
            accessLevel: 1
        }
    },
    {
        path: '/admin',
        component: () =>
            import('../pages/admin.vue'),
        meta: {
            accessLevel: 6
        }
    },
    {
        path: '/plans',
        component: () =>
            import('../pages/plans.vue')
    },
    {
        path: '/servers',
        component: () =>
            import('../pages/servers.vue'),
        meta: {
            accessLevel: 1
        }
    },
    {
        path: '/apps',
        component: () =>
            import('../pages/apps.vue')
    },
    {
        path: '/faq',
        component: () =>
            import('../pages/faq.vue')
    },
    {
        path: '/referral',
        component: () =>
            import('../pages/referral.vue'),
        meta: {
            accessLevel: 1
        }
    },
    {
        path: '/setup',
        component: () =>
            import('../pages/setup.vue'),
        meta: {
            accessLevel: 1
        }
    },
    {
        path: '/401',
        component: () =>
            import('../pages/401.vue')
    },
    {
        path: '/404',
        component: () =>
            import('../pages/404.vue')
    },
    { path: '*', redirect: '/404' },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {

        if (to.hash) return {
            selector: to.hash,
            offset: { x: 0, y: 75 }
        }

        if (savedPosition) return savedPosition

        return { x: 0, y: 0 }

    }
})

router.beforeEach((to, from, next) => {

    if (to.meta.guestOnly) {

        // validate guest only pages
        if (Cookies.get('auth') === undefined) next()
        else {

            router.app.$root.$bvToast.toast('You are already logged in.', {
                title: 'Logged in',
                variant: 'warning'
            })

            next('/dashboard')

        }

    } else if (to.meta.accessLevel) {

        // validate if the user is logged in
        if (Cookies.get('auth') === undefined) {

            router.app.$root.$bvToast.toast('You must log in before you can view this page.', {
                title: 'Log in',
                variant: 'warning'
            })

            next('/login')

        }
        // validate access level
        else if (JSON.parse(Cookies.get('auth')).accessLevel >= to.meta.accessLevel) next()
        else next('/401')

    } else next()

})

export default router